import React, { useState, useEffect } from 'react';
import ConfirmDialog from './ConfirmDialog';
import { setConfirmDialogHandler } from '../../services/confirm-service';

const ConfirmDialogManager = () => {
  const [dialogState, setDialogState] = useState({
    open: false,
    title: '',
    content: '',
    resolve: null,
    disableBackdropClose: true,
  });

  useEffect(() => {
    setConfirmDialogHandler(({ title, content, resolve, disableBackdropClose = true }) => {
      setDialogState({ open: true, title, content, resolve, disableBackdropClose });
    });
  }, []);

  const handleClose = () => {
    // Capture resolve before state update to prevent race condition
    const { resolve } = dialogState;
    setDialogState((prev) => ({ ...prev, open: false }));
    resolve?.(false);
  };

  const handleConfirm = () => {
    // Capture resolve before state update to prevent race condition
    const { resolve } = dialogState;
    setDialogState((prev) => ({ ...prev, open: false }));
    resolve?.(true);
  };

  return (
    <ConfirmDialog
      open={dialogState.open}
      title={dialogState.title}
      content={dialogState.content}
      onClose={handleClose}
      onConfirm={handleConfirm}
      disableBackdropClose={dialogState.disableBackdropClose}
    />
  );
};

export default ConfirmDialogManager;
